import {
  getEmpPayroll,
  getListOfEmployeeWithPayroll,
  getListOfEmployeeWithPayrollData,
  getpayrollData,
  sharePayrollByMonthYear,
} from 'services/axios/payroll'

export const actions = {
  GET_EMP_PAYROLL_LIST: 'GET_EMP_PAYROLL_LIST',
  HANDLE_PAYROLL_PAGINATION: 'HANDLE_PAYROLL_PAGINATION',
  FETCH_PAYROLL_DATA: 'FETCH_PAYROLL_DATA',
  EMPLOYEE_LIST_WITH_PAYROLL: 'EMPLOYEE-LIST_WITH_PAYROLL',
  TOGGLE_LOADING_PAYROLL: 'TOGGLE_LOADING_PAYROLL',
  EMPLOYEE_LIST_WITH_PAYROLL_DATA: 'EMPLOYEE-LIST_WITH_PAYROLL_DATA',
  SHARE_PAYROLL_BY_MONTH_YEAR: 'SHARE_PAYROLL_BY_MONTH_YEAR',
}
export const getPayrollList = ({ skip, limit, locationId = null, empName = null, month, year }) => {
  return async (dispatch) => {
    const response = await getEmpPayroll({ skip, limit, locationId, empName, month, year })
    dispatch({ type: actions.GET_EMP_PAYROLL_LIST, payload: response?.data?.data })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAYROLL_PAGINATION',
    payload: pagination,
  }
}

export const getpayrollDetail = ({ userId, month, year }) => {
  return async (dispatch) => {
    try {
      const response = await getpayrollData(userId, month, year) // Example function to fetch payroll data
      console.log(response, ' payroll sj')
      dispatch({ type: actions.FETCH_PAYROLL_DATA, payload: response?.data })
    } catch (error) {
      dispatch({ type: 'GET_PAYROLL_DETAIL_FAILURE', error })
    }
  }
}

export const toggleLoading = (value) => {
  return {
    type: actions.TOGGLE_LOADING_PAYROLL,
    payload: value,
  }
}

export const getEmployeesWithPayroll = ({
  skip,
  limit,
  month,
  year,
  userRole = null,
  locationId = null,
  userProcess,
  depId,
}) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))
    const response = await getListOfEmployeeWithPayroll({
      skip,
      limit,
      month,
      year,
      userRole,
      locationId,
      userProcess,
      depId,
    })
    dispatch({ type: actions.EMPLOYEE_LIST_WITH_PAYROLL, payload: response?.data?.data })
    dispatch(toggleLoading(false))
  }
}

export const getEmployeesWithPayrollData = ({
  month,
  year,
  userRole = null,
  locationId = null,
  userProcess,
  depId,
}) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))
    const response = await getListOfEmployeeWithPayrollData({
      month,
      year,
      userRole,
      locationId,
      userProcess,
      depId,
    })
    dispatch({ type: actions.EMPLOYEE_LIST_WITH_PAYROLL_DATA, payload: response?.data?.data })
    dispatch(toggleLoading(false))
  }
}

export const sharePayroll = (month, year) => {
  return async (dispatch) => {
    try {
      const response = await sharePayrollByMonthYear({ month, year })
      dispatch({
        type: actions.SHARE_PAYROLL_BY_MONTH_YEAR,
        payload: response?.data, // The shared payroll data or any confirmation message
      })
    } catch (error) {
      console.error(error)
    }
  }
}
